//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { SamplingCampaignRequest } from '@apis/campaign-requests/sampling/campaign-requests/samplingCampaignRequestsApiModel';

export const CampaignRequestType = {
  Creators: 'creators',
  Sampling: 'sampling',
} as const;

export type CampaignRequestType =
  (typeof CampaignRequestType)[keyof typeof CampaignRequestType];

export const CampaignManagerType = {
  Bazaarvoice: 'BAZAARVOICE',
  Client: 'CLIENT',
} as const;

export type CampaignManagerType =
  (typeof CampaignManagerType)[keyof typeof CampaignManagerType];

export const CommunityType = {
  Member: 'member',
  Creator: 'creator',
} as const;

export type CommunityType = (typeof CommunityType)[keyof typeof CommunityType];

export interface CampaignRequestBase {
  communityType?: CommunityType;
  name?: string;
  type?: CampaignRequestType;
}

export interface CreatorCampaignRequest extends CampaignRequestBase {
  type?: 'creators';
  campaignManager?: CampaignManagerType;
  startDate?: string; // It's a string because the user can input text as a date in "MM/DD/YYYY" format
  endDate?: string; // It's a string because the user can input text as a date in "MM/DD/YYYY" format
  name?: string;
  hashtags?: string; // Space separated (Starts with `#` only on the UI side for preview)
  mentions?: string; // Space separated (Starts with `@` only on the UI side for preview)
}

export type CampaignRequest = SamplingCampaignRequest | CreatorCampaignRequest;
